import { LocalGameGateway, type EncodedCore, type PracticeOptions } from '@mendikot/app-core';
import type { BotLevel } from '@mendikot/engine';

const KEY = 'mendikot.practice.v1';
export const PRACTICE_UID = 'you';

interface SavedPractice {
  core: EncodedCore;
  seed: string;
  botLevel: BotLevel;
  savedAt: number;
}

function read(): SavedPractice | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SavedPractice) : null;
  } catch {
    return null;
  }
}

/** A practice match that can be resumed (only while a match is in progress). */
export function loadPractice(): SavedPractice | null {
  const saved = read();
  return saved && saved.core.meta.status === 'PLAYING' ? saved : null;
}

export function clearPractice(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
  runtime = null;
}

let runtime: LocalGameGateway | null = null;

/** Keeps one practice table alive across route changes and persists every commit for resume. */
export function practiceGateway(
  options?: Omit<PracticeOptions, 'onCommit' | 'uid'>,
): LocalGameGateway | null {
  if (options) {
    const botLevel = options.botLevel ?? 'normal';
    let gateway: LocalGameGateway | null = null;
    gateway = new LocalGameGateway({
      ...options,
      uid: PRACTICE_UID,
      onCommit: (core) => {
        try {
          localStorage.setItem(
            KEY,
            JSON.stringify({
              core,
              seed: gateway?.seed ?? '',
              botLevel,
              savedAt: Date.now(),
            } satisfies SavedPractice),
          );
        } catch {
          // Storage full or blocked — the game still works, it just can't be resumed.
        }
      },
    });
    runtime = gateway;
    return runtime;
  }
  if (runtime) return runtime;
  const saved = loadPractice();
  if (!saved) return null;
  return practiceGateway({
    name: '',
    avatarId: 'peacock',
    restore: saved.core,
    seed: saved.seed,
    botLevel: saved.botLevel,
  });
}
